import axiosClient from "../common/axios/axiosConfig";
import { messageDTO } from "../common/dtos/messageDTO";

interface requestDTO {
  talk: boolean;
  sender: number;
  receiver: number;
  order: "desc" | "asc";
  offset: number;
  limit: number;
}

const getMessages = async (params: requestDTO): Promise<messageDTO[]> => {
  const codu = localStorage.getItem("user_info")
    ? JSON.parse(localStorage.getItem("user_info") || "{}").codu
    : null;

  let user_chat;
  if (params.sender === codu) {
    user_chat = params.receiver;
  } else {
    user_chat = params.sender ?? codu;
  }

  const response = await axiosClient.get("list-messages", {
    params,
  });

  if (params.talk) {
    if (user_chat !== codu) {
      localStorage.setItem(`${codu}.list-messages`, JSON.stringify(response.data));
    }
  }

  return response.data;
};

export default getMessages;
